// extracted by mini-css-extract-plugin
module.exports = {"signup-page":"styles_signup-page__2vhEr","content":"styles_content__WxwuC","body":"styles_body__wWVYS"};